/**
 * The easyQue signature shown at the bottom of every customer registration
 * page, so the pages can't drift apart again.
 */
import React from "react";
import { Box, Typography, Link as MuiLink } from "@mui/material";

const CustomerFooter = () => (
    <Box mt={4} textAlign="center">
        <Typography variant="body2">
            <MuiLink href="#" underline="hover">
                easyQue
            </MuiLink>{" "}
            (c) by Digifront
        </Typography>
        <Typography variant="body2" mt={1}>
            <MuiLink href="mailto:sales@digifront.biz" underline="hover">
                sales@digifront.biz
            </MuiLink>
        </Typography>
    </Box>
);

export default CustomerFooter;
